import { API_URL } from "../config/connect";
import { throwResponseError } from "../utils/apiErrorHandler";

let templatesPromise = null;

/**
 * Fetch agreement templates (auth required).
 * Cached at module level for the session — templates are near-static, so
 * repeated callers share one in-flight request and get the resolved result
 * instantly. Cache resets only on failure so a retry is possible.
 * @returns {Promise<Object>} Templates response
 */
export async function getAgreementTemplates() {
    if (templatesPromise) return templatesPromise;

    templatesPromise = (async () => {
        const accessToken = localStorage.getItem("access_token");
        if (!accessToken) {
            throw new Error("Access token is missing");
        }

        const endpoint = `${API_URL}/api/v1/agreement_templates`;
        const response = await fetch(endpoint, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
            },
        });

        if (!response.ok) {
            await throwResponseError(response);
        }

        return response.json();
    })().catch((error) => {
        console.error('Failed to fetch agreement templates:', error);
        templatesPromise = null;
        throw error;
    });

    return templatesPromise;
}